<template>
  <div>
    <div class="register mt-9" style="position: relative; height: 100%">
      <v-card max-width="700" class="mx-auto" style="position: relative">
        <div style="position: absolute; right: 18px; top: 18px">
          <v-btn icon @click="dialog = true">
            <v-icon>edit</v-icon>
          </v-btn>

          <v-dialog v-model="changePasswordDialog" width="500" persistent>
            <ProfileForgotPassword
              :closeDialog="() => (changePasswordDialog = false)"
              :dialog="changePasswordDialog"
              :codeSent="true"
            />
          </v-dialog>
        </div>
        <v-container class="pa-6 pb-0" fluid grid-list-md>
          <v-row>
            <v-col md="4">
              <div class="p-relative">
                <v-list-item-avatar width="90%" height="auto">
                  <input type="file" class="d-none"
                         @input="onFileSelect"
                         ref="avatarInput">
                  <v-img @click="onAvatarClick"
                         aspect-ratio="1"
                         :src="$store.getters.userAvatar"></v-img>
                </v-list-item-avatar>
                <v-btn @click="onAvatarClick" absolute icon style="right: -10px; top: 0;">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
              <div class="py-5">
                <div @click="changePasswordDialog = true" class="cursor-pointer">
                  <v-icon>lock</v-icon>
                  <span>&nbsp; <translate>Change password</translate></span>
                </div>
                <div class="mt-2 cursor-pointer" @click="$store.dispatch('auth/signOut')">
                  <v-icon>exit_to_app</v-icon>
                  <span>&nbsp; <translate>Log Out</translate></span>
                </div>
              </div>
            </v-col>
            <v-col md="8" v-if="userInfo">
              <div class="ma-auto profile-name">
                {{ userInfo.given_name }} {{ userInfo.family_name }}
              </div>
              <v-row align="center">
                <v-col class="profile-info">
                  <v-text-field
                    class="pa-0"
                    prepend-icon="email"
                    single-line
                    :value="userInfo.email"
                    disabled
                  ></v-text-field>
                  <v-text-field
                    class="pa-0"
                    prepend-icon="map"
                    single-line
                    :value="userLocality"
                    disabled
                  ></v-text-field>
                  <div style="cursor: pointer" @click="onOrgNameClick">
                    <v-text-field
                      class="pa-0"
                      prepend-icon="business"
                      single-line
                      :value="orgInfo.name"
                      disabled
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>

    <profile-edit-dialog :value="dialog"
                         @close-dialog="dialog = false" />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapState } from 'vuex'
import ProfileEditDialog from '@/components/Profile/ProfileEditDialog'
import { Storage } from 'aws-amplify'
import profileApi from '@/services/apiCalls/profile'
import ErrorHandler from '@/utils/ErrorHandler'

export default {
  name: 'Profile',

  mixins: [validationMixin],

  data() {
    return {
      dialog: false,
      changePasswordDialog: false,
    }
  },

  components: {
    ProfileEditDialog,
    ProfileForgotPassword: () => import('@/components/app/profile/ProfileForgotPassword'),
  },

  computed: {
    ...mapState('auth', { userInfo: (state) => state.user, orgInfo: (state) => state.orgInfo }),

    userLocality() {
      if (this.orgInfo && this.orgInfo.address) {
        const address = this.orgInfo.address
        return `${address.locality}, ${address.region}, ${address.streetAddress}, ${address.postalCode}`
      }
    },
  },

  methods: {
    onOrgNameClick() {
      this.$root.openOrganizationInfoDialog(this.orgInfo.identifier);
    },

    onAvatarClick() {
      this.$refs.avatarInput.click();
    },

    async onFileSelect(ev) {
      if (ev.target.files[0]) {
        const file = ev.target.files[0];
        if (!file.type.includes('image')) {
          this.$store.commit('setAppErrorCardState', {
            state: true,
            errorText: 'The format of this file is not supported.',
          })
          return;
        }
        if (file.size > 1000000) {
          this.$store.commit('setAppErrorCardState', {
            state: true,
            errorText: 'Maximum allowed file size is 1 mb.',
          })
          return;
        }
        try {
          this.$store.commit('spinner', true);
          const { key } = await Storage.put('avatar', file, {
            level: 'private',
            bucket: process.env.VUE_APP_MARKETPLACE_STATIC,
            contentType: file.type,
          });
          await profileApi.updateUserAvatar(this.$store.state.auth.user.sub, `private/${localStorage.getItem('identityId')}/${key}`);
          await this.$store.dispatch('getUserProfile');
        } catch (e) {
          ErrorHandler(e, this)
        } finally {
          this.$store.commit('spinner', false);
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
.v-image {
  cursor: pointer;
}
.profile-name {
  font-size: 24px;
  font-weight: 400;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em;
  font-family: 'Roboto', sans-serif;
}
</style>
